export default "__VITE_ASSET__axGjOZNn__"